import { IMenuItemWithFullPath } from 'layout/MainLayout/Sidebar/MenuList/types';

export const getMenuItemSelected = (menuItemList: IMenuItemWithFullPath[], allPathname: string) => {
    const pathWithouthTenant = allPathname.split('/').slice(2).join('/');
    return menuItemList.find((item) => item.fullPath === pathWithouthTenant);
};
